import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import * as images from "../../constants/Images";
//import CommonService from "../../services/CommonService";
import "./AddAnswer.css";
import Avatar from "react-avatar";
//import { socket } from "../../common/Socket";
import Loadspinner from "../Loadspinner";
import Encrypt from "../../services/Encryption";
import Decrypt from "../../services/Decryption";
import { createAnswer } from "../../constants/ApiEndpoints";
import { APICall } from "../../helpers/API/APICalls";
import CommonConstants from "../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";

function AddAnswer(props) {
  const [answer, setAnswer] = useState("");
  const [answered, showAns] = useState(false);
  const [myAnswer, setMyAnswer] = useState("");
  //const [creatorId, setCreator] = useState();

  const [loading, setLoading] = useState(false);
  const [dp, setDp] = useState("");
  const [empName, setName] = useState("");
  const handleChange = (e) => {
    setAnswer(e.target.value);
  };

  useEffect(() => getDetails(), []);

  const getDetails = async () => {
    let dp = await getFromEncLocalStorage("profile_pic");
    let firstName = await getFromEncLocalStorage("firstname");
    // let creator = await getFromEncLocalStorage("employeenumber");
    let lastName = await getFromEncLocalStorage("lastname");
    let name = firstName + " " + lastName;

    setDp(dp);
    setName(name);
    // setCreator(creator);
  };

  const addAnswer = async () => {
    setLoading(true);
    let id = props.id;
    // let answerData = {
    //   question_id: id,
    //   answer_description: answer,
    //   answer_file: null,
    //   created_by_id: props.creator,
    // };

    // //     const res = await CommonService.addAnswer(answerData);
    // // if (res) {
    // //
    // // }
    // // let { data } = res;
    // let eData = JSON.stringify({data :answerData, encryptionType: true});
    // let encryptedData = Encrypt(eData);
    // let newData = {
    //   data: encryptedData,
    // };

    showAns(true);

    const employeeNum = getFromEncLocalStorage("employeenumber");
    const fName = getFromEncLocalStorage("firstname");
    const lName = getFromEncLocalStorage("lastname");
    const empdepName = getFromEncLocalStorage("empDeptName");
    const nameofPosition = getFromEncLocalStorage("nameofposition");

    const answerData = {
      question_id: id,
      answer: answer,
      answer_by_id: props.creator,
      answer_by_name: `${fName} ${lName}`,
      nameofposition: nameofPosition,
      department: empdepName,
      loggedin_userid: employeeNum,
    }

    const resp = await APICall(createAnswer, answerData);

    console.log("createAnswer resp : ", resp);

    if (!resp?.data?.IsSucessful) {
      showAns(false);
      alert(resp?.data?.status);
    } else {
      props.sendAns(resp?.data);
    }

    // window.socketObj.emit("createAnswer", newData);
    // showAns(true);

    // window.socketObj.on("createAnswerBroadcast", (encData) => {
    //   let data = JSON.parse(Decrypt(encData.data));
    //   if (!data.IsSucessful) {
    //     showAns(false);
    //     alert(data.status);
    //   } else {
    //     props.sendAns(data);
    //   }
    // });

    setMyAnswer(answer);
    setAnswer("");
    setLoading(false);
  };

  return (
    <div>
      <Loadspinner filename="AddAnswer.js" isLoading={loading} isMiddle="true" />
      {props.isDetail ? null : answered ? (
        <div className="display-col">
          <h6>Answers</h6>
          <div className="display-row" style={{ marginTop: "10px" }}>
            {dp ? (
              <img src={dp} alt="Profile pic" className="comment-dp-img" />
            ) : (
              <Avatar
                name={empName}
                size="30px"
                round={true}
                style={{ marginRight: "10px" }}
              />
            )}
            <p>
              {myAnswer.length > 150
                ? myAnswer.substring(0, 150) + "..."
                : myAnswer}
            </p>
          </div>
          <hr />
        </div>
      ) : null}
      <div className="display-row" style={{ alignItems: "center" }}>
        {dp ? (
          <img src={dp} alt="Profile pic" className="comment-dp-img" />
        ) : (
          <Avatar name={empName} size="30px" round={true} />
        )}
        <input
          type="text"
          className="form-control comment-input"
          placeholder="Your Answer"
          onChange={handleChange}
          value={answer}
          autoComplete={CommonConstants.autoCompleteInput}
        />
        <img
          src={images.send}
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Add"
          className="send-img"
          onClick={addAnswer}
        />
      </div>
    </div>
  );
}

export default AddAnswer;

AddAnswer.propTypes = {
  id: PropTypes.number,
  sendAns: PropTypes.func,
  isDetail: PropTypes.bool,
  creator: PropTypes.string,
};
